import type { Tile6UpProps, TilesProps } from './types';
import './Tile6UpTips.scss';
import { BuildContextProvider } from '../../providers';
import SixTileCarousel from './SixTileCarousel';

export default function Tile6UpTips({ tiles, variant }: Tile6UpProps) {
    return (
        <BuildContextProvider>
            <SixTileCarousel
                className="tile6up-tips"
                alignText="center"
                data-testid="six-tile-tips"
                // max five tiles and no links in tiles
                tiles={tiles.slice(0, 5).map((tile: TilesProps) => ({
                    internalTitle: tile.internalTitle,
                    title: tile.title,
                    image: tile.image,
                    sysId: tile.sysId,
                }))}
                breakpoints={{
                    560: {
                        perView: 2.5,
                        gap: 8,
                    },
                }}
                variant={variant}
                overrideDefaultClass
            />
        </BuildContextProvider>
    );
}
